import { composeReducers } from 'common/util';
import {
    LOAD_DOCUMENTS,
    SET_FILE_STATE,
    REMOVE_FILES,
    LOAD_DESCRIPTOR_SYSTEM_NAMES,
} from 'binder/actions/files';
import lodash from 'lodash';

export function setDescriptorSystemNames(state, action) {
    if (!action || action.type !== LOAD_DESCRIPTOR_SYSTEM_NAMES) {
        return state;
    }

    const bySystemName = {};
    action.payload.descriptors.forEach(descriptor => {
        if (descriptor.systemName) {
            if (!lodash.hasIn(bySystemName, descriptor.systemName)) {
                bySystemName[descriptor.systemName] = [];
            }
            bySystemName[descriptor.systemName].push(descriptor.id);
        }
    });

    return {
        ...state,
        descriptors: action.payload.descriptors,
        descriptorsBySystemName: bySystemName,
    };
}

export function loadDocuments(state, action){
    if(!action || action.type !== LOAD_DOCUMENTS){
        return state;
    }

    const { count, method, folder, query, documents, duplicates } = action.payload;
    const assignedDuplicatesToDocument = assignDuplicatesToDocument(documents, duplicates);
    const sortedDocumentsByIssues = sortDocumentsByIssues(assignedDuplicatesToDocument);
    let existingDocuments = method === 'replace' ? [] : lodash.get(state, 'files.documents', []);
    let finalDocuments;
    if (method === 'prepend') {
        finalDocuments = lodash.uniqBy([...sortedDocumentsByIssues, ...existingDocuments], 'id');
    } else {
        finalDocuments = lodash.uniqBy([...existingDocuments, ...sortedDocumentsByIssues], 'id');
    }

    const unfiledCount = getUpdatedUnfiledCount(folder, count, state);
    const unfiledDocumentsLoadingError = verifyUnfiledDocumentsLoadingError(folder, query, count, unfiledCount);

    return {
        ...state,
        files: {
            ...state.files,
            ...distributeDocuments(finalDocuments, folder),
            documentCount: count,
            hasNewDocumentConversionResult: false,
            unfiledDocumentsLoadingError
        },
        binder: {
            ...state.binder,
            countUnfiledDocuments: unfiledCount
        }
    };
}

function verifyUnfiledDocumentsLoadingError(folder, query, count, unfiledCount) {
    return (lodash.isNil(folder) && lodash.isNil(query) && !lodash.isEqual(count, unfiledCount));
}

function distributeDocuments(documents, folder) {
    if(folder === 'unfiled') {
        return {unfiledDocuments: documents};
    }
    return {documents};
}

function getUpdatedUnfiledCount(folder, count, state) {
    if(folder === 'unfiled' && lodash.get(state, 'files.hasNewDocumentConversionResult')) {
        return count;
    }
    return lodash.get(state, 'binder.countUnfiledDocuments');
}

function assignDuplicatesToDocument(documents, duplicates = []){
    if(lodash.isEmpty(duplicates)){
        return documents;
    }

    return duplicates.map( duplicate => {
        const duplicateDocument = documents.find( document => document.id === duplicate.documentId);
        return Object.assign({}, { duplicates: duplicate.duplicates }, duplicateDocument);
    });
}

function sortDocumentsByIssues(documents) {
    return lodash.orderBy(documents,
        ['conversionStatus', (doc) =>
            lodash.isEmpty(doc.duplicates)
        ],
        [true, false]
    );
}

export function setFileState(state, action) {
    if (!action || action.type !== SET_FILE_STATE) {
        return state;
    }

    const {property, value} = action.payload;

    return {
        ...state,
        files: {
            ...state.files,
            [property]: value
        }
    };
}

export function removeFiles(state, action) {
    if (!action || action.type !== REMOVE_FILES) {
        return state;
    }

    const newState = { ...state };
    lodash.unset(newState, 'files');
    return newState;
}

export default composeReducers(
    loadDocuments,
    setFileState,
    removeFiles,
    setDescriptorSystemNames,
);
